module.exports = __webpack_public_path__ + "static/media/Slide20.7698be0c.jpg";